/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import TimePickerHour from 'app/components/common/TimePickerHour.jsx';
import TimePickerMinute from 'app/components/common/TimePickerMinute.jsx';
import TimePickerMeridiem from 'app/components/common/TimePickerMeridiem.jsx';
import DropdownList from 'react-widgets/DropdownList';
import CategoryItem from 'app/components/DropDownItems/CategoryItem.jsx';
import * as _ from 'underscore';

class QueueScheduleRowEditor extends React.Component {
    constructor(props) {
        super(props);

        let category = null;

        if (props.schedule.s_tagID !== 0) {
            category = _.find(props.categoryList, {id: props.schedule.s_tagID});
        }

        this.state = {
            time: null,
            category,
            categoryList: this.props.categoryList.slice(1)
        };

        this.onTimeChange = this.onTimeChange.bind(this);
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.onSaveSchedule = this.onSaveSchedule.bind(this);

    }

    componentDidMount() {
        let time = new moment(),
            splitTime = _.clone(this.props.schedule.s_startTime).split(":");

        if (this.props.user.detail && this.props.user.detail.timezone) {
            time = moment().tz(this.props.user.detail.timezone);
        }

        time.hour(splitTime[0]);
        time.minute(splitTime[1]);

        this.setState({
            time
        });

    }

    onTimeChange(value, e) {

        let time = moment(this.state.time);

        switch (e.currentTarget.dataset.field) {
            case "hours":
                time.tz(this.props.user.detail.timezone);
                time.hour(value);
                break;

            case "minutes":
                time.minute(value);
                break;

            case "meridiem":
                if (time.hour() > 12 && value === 'AM') {
                    time.subtract(12, 'hours');
                } else if (time.hour() < 12 && value === 'PM') {
                    time.add(12, 'hours');
                } else {
                    if (value === 'AM') {
                        time.hour(0);
                    } else {
                        time.hour(12);
                    }
                }
                break;

            default:
                break;
        }

        this.setState({
            time
        });

    }

    onCategoryChange(category) {

        this.setState({
            category: category
        });

    }

    onSaveSchedule() {

        let categoryId = 0;

        if (this.state.category) {
            categoryId = this.state.category.id;
        }

        this.props.changeHandler(this.props.schedule.s_id, this.state.time.format('HH:mm:00'), categoryId);

    }

    render() {
        let categoryOnClick = null,
            disabled = false,
            error = null;

        if (this.props.user.perms.resources && !this.props.user.perms.resources.categories) {
            disabled = true;
            categoryOnClick = this.props.onCategoryUpgrade;
        }

        if (this.props.error) {
            error = (
                <div className="schedule-error">{this.props.error}</div>
            );
        }

        return (
            <tr>
                <td></td>
                <td colSpan="7" className="queue-schedule-controls">
                    {error}
                    <div className="time-pickers">
                        <TimePickerHour
                            {...this.props}
                            changeHandler={this.onTimeChange}
                            scheduleTime={this.state.time}
                            id={this.props.schedule.s_id}/>
                        <TimePickerMinute
                            {...this.props}
                            changeHandler={this.onTimeChange}
                            scheduleTime={this.state.time}
                            id={this.props.schedule.s_id}/>
                        <TimePickerMeridiem
                            {...this.props}
                            changeHandler={this.onTimeChange}
                            scheduleTime={this.state.time}
                            id={this.props.schedule.s_id}/>
                    </div>
                    <div className="category-dropdown" onClick={categoryOnClick}>
                        <DropdownList
                            data={this.state.categoryList}
                            dataKey='id'
                            filter={false}
                            renderListItem={({ item }) => {
                                return (
                                    <CategoryItem
                                        item={item}/>
                                );
                            }}
                            renderValue={({ item }) => {
                                return (
                                    <CategoryItem
                                        item={item}/>
                                );
                            }}
                            placeholder="Choose Category"
                            aria-label="Category"
                            className="category-drop"
                            disabled={disabled}
                            value={this.state.category}
                            onChange={this.onCategoryChange} />
                    </div>
                    <button className="btn-secondary active save-schedule active" onClick={this.onSaveSchedule}>
                        save
                    </button>
                </td>
                <td></td>
            </tr>
        );
    }
}

QueueScheduleRowEditor.displayName = "QueueScheduleRowEditor";

QueueScheduleRowEditor.propTypes = {

};

QueueScheduleRowEditor.defaultProps = {

};

export default QueueScheduleRowEditor;
